import React from 'react';
import './TermsConditionsPage.css';
import Footer from '../../components/Footer/Footer';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';

const TermsConditionsPage: React.FC = () => {
  return (
    <div className="terms-conditions-page">
      {/* Navigation Header */}
      <SmartNavigation forceVariant="light" />
      
      {/* Terms & Conditions Content */}
      <div className="terms-conditions-content">
        <div className="terms-conditions-container">
          <h1>Terms & Conditions</h1>
          
          <div className="terms-conditions-text">
            <p className="last-updated">Last updated: January 2025</p>
            
            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Awasi website or making a reservation at any of our properties, 
                you accept and agree to be bound by the terms and provision of this agreement. If you do not 
                agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2>2. Booking and Reservations</h2>
              <p>
                All bookings are subject to availability and confirmation. We reserve the right to refuse any 
                reservation request. A valid credit card is required to guarantee your reservation. Full payment 
                terms will be communicated at the time of booking.
              </p>
              <ul>
                <li>Reservations must be made by guests aged 18 years or older</li>
                <li>Valid identification is required at check-in</li>
                <li>Room rates are subject to change without notice until booking is confirmed</li>
                <li>All prices are quoted in the local currency unless otherwise stated</li>
              </ul>
            </section>

            <section>
              <h2>3. Cancellation Policy</h2>
              <p>
                Our cancellation policy varies by property and season. The specific cancellation terms applicable 
                to your reservation will be clearly communicated at the time of booking. General guidelines include:
              </p>
              <ul>
                <li>Cancellations made 60+ days prior to arrival: Full refund minus processing fee</li>
                <li>Cancellations made 30-59 days prior to arrival: 50% of total stay charged</li>
                <li>Cancellations made less than 30 days prior to arrival: 100% of total stay charged</li>
                <li>No-shows will be charged the full amount of the reservation</li>
                <li>Early departures are non-refundable</li>
              </ul>
            </section>

            <section>
              <h2>4. Property Rules and Guest Conduct</h2>
              <p>
                Guests are expected to conduct themselves in a respectful manner and comply with all property 
                rules. We reserve the right to terminate your stay without refund for violation of property 
                rules or disruptive behavior. General property rules include:
              </p>
              <ul>
                <li>Quiet hours must be observed between 10:00 PM and 7:00 AM</li>
                <li>Smoking is prohibited in all indoor areas</li>
                <li>Pets are not permitted unless specifically authorized</li>
                <li>Maximum occupancy limits must be strictly observed</li>
                <li>Guests are responsible for any damage to property or furnishings</li>
              </ul>
            </section>

            <section>
              <h2>5. Liability and Disclaimers</h2>
              <p>
                While we take every precaution to ensure the safety and security of our guests, Awasi and its 
                properties shall not be liable for any loss, damage, or injury to persons or property, however 
                caused. Guests participate in all activities at their own risk.
              </p>
              <p>
                We strongly recommend that all guests obtain comprehensive travel insurance to cover personal 
                belongings, medical expenses, and trip cancellation.
              </p>
            </section>

            <section>
              <h2>6. Force Majeure</h2>
              <p>
                Awasi shall not be liable for any failure or delay in performance under these Terms which is due 
                to fire, flood, earthquake, pandemic, governmental action, war, terrorism, or other unforeseeable 
                cause that is beyond our reasonable control.
              </p>
            </section>

            <section>
              <h2>7. Privacy and Data Protection</h2>
              <p>
                Your privacy is important to us. All personal information collected during the booking process 
                and your stay is handled in accordance with our Privacy Policy. By using our services, you 
                consent to the collection and use of your information as described in our Privacy Policy.
              </p>
            </section>

            <section>
              <h2>8. Intellectual Property</h2>
              <p>
                All content on the Awasi website, including text, graphics, logos, images, and software, is the 
                property of Awasi or its content suppliers and is protected by international copyright laws. 
                Unauthorized use or reproduction is strictly prohibited.
              </p>
            </section>

            <section>
              <h2>9. Governing Law and Dispute Resolution</h2>
              <p>
                These Terms and Conditions shall be governed by and construed in accordance with the laws of the 
                country where the specific Awasi property is located. Any disputes arising out of or in connection 
                with these terms shall be resolved through good faith negotiation or, if necessary, through 
                binding arbitration.
              </p>
            </section>

            <section>
              <h2>10. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these Terms and Conditions at any time. Any changes will be 
                effective immediately upon posting on our website. Your continued use of our services following 
                any changes indicates your acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2>11. Contact Information</h2>
              <p>
                If you have any questions about these Terms and Conditions, please contact us at:
              </p>
              <div className="contact-info">
                <p>Awasi</p>
                <p>Email: info@awasi.com</p>
                <p>Phone: +(56-2) 2233-9641</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Instagram Feed + Footer */}
      <InstagramSection />
      <Footer />
    </div>
  );
};

export default TermsConditionsPage;